<div class="container-table" [ngClass]="!enablePagination ? 'pb-{{paddingBottomClass}}' : ''" [style]="containerCustomStyle">
    <div class="tableFixHead" [style]="fixHeadCustomStyle">
        <table class="table_data" [class.txt-wrap]="textWrap">
            <thead [ngClass]="headerStyle">
                <tr [style.height]="headersHeight">
                    @if(isActionsEnabled){
                        <th [style.width]="buttonsContainerWidth" [style.paddingLeft]="buttonsContainerPaddingLeft"></th>
                    }
                    @for (header of tableHeaders; track $index) {
                        @if (shouldShowColumn(header)) { <!-- Nuevo condicional -->
                            <th
                              [class.sticky-left]="$index === firstColumnIndex && firstColumnStickyLeft"
                              [style.padding-left]="$index === firstColumnIndex && headerStyle === 'new' && firstColumnPaddingLeft"
                              [style.padding-right]="$index === lastColumnIndex && lastColumnPaddingRight"
                              [style.color]="headerStyle === 'new' && headersColorIsPrimary && 'var(--so-primary)'"
                              [style.width]="header.columnWidth || 'auto'">
                                <div class="d-flex" [class.has-info-button]="header.columnInfoFunction">
                                    @if (header.columnInfoFunction) {
                                    <app-so-svg-icon class="cursor-pointer column-info-button" src="assets/img/mdi-circle.svg" [size]=".55" (click)="header.columnInfoFunction()" />
                                    }
                                    {{ headersCaseIsUpper ? (header.header| translated: header.header).toUpperCase() : header.header| translated: header.header }}
                                    <mat-icon class="cursor-pointer" (click)="onClickShortByData(header.dataName)" [ngStyle]="filterBy === header.dataName ? {'color': 'var(--so-secondary)'} : {}">unfold_more</mat-icon>
                                </div>
                            </th>
                        }
                    }

                    @if(showSwitches){
                        <th class="text-end pe-5" style="min-width: 135px; width: 136px;">{{switchHeader | uppercase}}</th>
                    }
                      @if(showIcons){
                        <th class="text-end pe-5" style="width: 125px;">{{ iconsHeader | uppercase }}</th>
                    }

                </tr>
            </thead>
            <tbody [ngClass]="headerStyle">
                @for (item of (enablePagination ? filteredData : tableData); let rowIndex = $index; track rowIndex) {
                    <tr (click)="onRowClic(item)"
                        [ngClass]="{'selected-row': enableRowSelection && selectedRow === item}"
                        [style.height]="rowsHeight"
                        [style.background]="rowColorFunction ? rowColorFunction(item) : ''"
                    >
                        @if (isActionsEnabled) {
                            <td [style.width]="buttonsContainerWidth" [style.paddingLeft]="buttonsContainerPaddingLeft">
                                <div class="d-flex">
                                    @if (editAction) {
                                        <app-button
                                            type="button"
                                            svg="mdi-pencil-outline-white"
                                            [scale]=".7"
                                            [injection]="{icon: 'margin-top: 0px !important', button: '' }"
                                            [applyStyles]="false"
                                            [applyChanges]="true"
                                            [width]="'100%'"
                                            (clicked)="editRow(item)"
                                        ></app-button>
                                    }
                                    @for (button of customButtons; track $index) {
                                        <app-button
                                            type="button"
                                            [svg]="button.svg"
                                            [scale]="button.scale ?? .7"
                                            [ngClass]="button.ngClass ?? null"
                                            [injection]="{icon: 'margin-top: 0px !important', button: '' }"
                                            [applyStyles]="false"
                                            [applyChanges]="true"
                                            [width]="'100%'"
                                            (clicked)="button.action(item)"
                                            (click)="$event.stopPropagation()"
                                            [disabled]="isButtonDisabled(button, item)"
                                            [matTooltip]="getTooltipContent(button, item)">
                                        </app-button>
                                    }
                                    @if (deleteAction) {
                                        <app-button
                                            type="button"
                                            svg="mdi-delete-forever-outline-danger"
                                            [scale]=".7"
                                            [injection]="{icon: 'margin-top: 0px !important', button: '' }"
                                            [applyStyles]="false"
                                            [width]="'100%'"
                                            (clicked)="deleteRow(item)"
                                        ></app-button>
                                    }
                                </div>
                            </td>
                        }
                        @for (header of tableHeaders; let columnIndex = $index; track columnIndex;) {
                          @if(shouldShowColumn(header)) { <!-- Nuevo condicional -->
                            <td
                              [style.color]="(enableRowSelection && selectedRow === item && header.whenSelected?.color) ? 'var(' + header.whenSelected?.color(item) + ')' : null"
                              [style.background]="(enableRowSelection && selectedRow === item && header.whenSelected?.backgroudColor) ? 'var(' + header.whenSelected?.backgroudColor(item) + ')' : (rowColorFunction ? rowColorFunction(item) : '')"
                              [class.sticky-left]="columnIndex === firstColumnIndex && firstColumnStickyLeft"
                              [style.padding-left]="columnIndex === firstColumnIndex && headerStyle === 'new' && firstColumnPaddingLeft"
                              [style.padding-right]="columnIndex === lastColumnIndex && lastColumnPaddingRight"
                              [style.width]="header.columnWidth || 'auto'"
                              [style.font-weight]="header.isBold ? 'bold' : (header.isSemiBold ? '600' : 'normal')"
                              matTooltip="{{ getPropertyValue(item, header.dataName) }}"
                              [matTooltipDisabled]="!isTextTruncated(cellElement)"
                              #cellElement>
                              <div [style]="header.customTDStyle || ''" [class.text-center]="header.centerText">
                                @if(header.isButton?.show){
                                  @if(getPropertyValue(item, header.dataName)){
                                      <app-button
                                        [text]="header.isButton?.text ?? 'Ver'"
                                        [svg]="header.isButton?.svg ?? 'mdi-link'"
                                        [type]="'button'"
                                        [iconAlignment]="'right'"
                                        [scale]=".7"
                                        [injection]="{ label: 'pt-2 ' }"
                                        [colorIcon]="header.isButton?.color ?? '--so-secondary'"
                                        [applyChanges]="true"
                                        (click)="header.isButton?.action(item)">
                                      </app-button>
                                  }
                                }
                                @else if (header.isIcon){
                                @if (header.isIcon.show(item)) {
                                  @if (header.isIcon.show(item) === true) {
                                    <app-so-svg-icon
                                        src="assets/img/{{ header.isIcon.svg(item) }}.svg"
                                        [color]="(header?.isIcon?.color && header?.isIcon?.color(item)) ?? '--so-secondary'"
                                        [size]="(header?.isIcon?.size && header?.isIcon?.size(item)) ?? .95"
                                        [applyChange]="true"
                                    />
                                  }
                                  @else {
                                    <span [style.paddingLeft]="!header.isIcon.whenShowTextPaddingLeft ? null : header.isIcon.whenShowTextPaddingLeft(item)">{{ header.isIcon.show(item) }}</span>
                                  }
                                }
                              }
                              @else if(header.badge?.show){
                                <app-so-badge
                                      [text]="!header.badge?.returnFullItem ? header.badge?.text(getPropertyValue(item, header.dataName)) : header.badge?.text(item)"
                                      [color]="!header.badge?.returnFullItem ? header.badge?.color(getPropertyValue(item, header.dataName)) : header.badge?.color(item)"
                                ></app-so-badge>
                              }@else{
                                @if (header.convertFunction && !header.hightlightText) {
                                    {{ header.convertFunction(getPropertyValue(item, header.dataName), item) }}
                                }@else {
                                    @if(header.isDate) {
                                        @if(header.showHours){
                                            {{ getPropertyValue(item, header.dataName) | date: 'dd/MM/yyyy HH:mm' }}
                                        }@else {
                                            {{ getPropertyValue(item, header.dataName) | date: 'dd/MM/yyyy' }}
                                        }
                                    }
                                    @else if(header.hightlightText) { <!-- Textos resaltados / con interacción-->
                                     @for(subText of rowsHighlights[rowIndex][columnIndex]; track subText; let subTextIndex = $index){
                                       @if (!subText.highlighted){
                                        <span [style.color]="(enableRowSelection && selectedRow === item && header.whenSelected?.color) ? 'var(' + header.whenSelected?.color(item) + ')' : null">{{ !header.convertFunction
                                            ? (!header.isUppercase ? subText.text : subText.text | uppercase)
                                            : header.convertFunction(!header.isUppercase ? subText.text : subText.text | uppercase) }}</span>
                                        }
                                        @else {
                                        <span
                                            [style.font-weight]="header.hightlightText.bold ? 'bold' : (header.hightlightText.semiBold ? '600' : null)"
                                            [style.color]="(enableRowSelection && selectedRow === item && header.whenSelected?.color) ? 'var(' + header.whenSelected?.color(item) + ')' : (header.hightlightText.color ? ('var(' + header.hightlightText.color + ')') : null)"
                                            [style.text-decoration-thickness]="'1.5px'"
                                            [style.text-decoration-line]="header.hightlightText.underline === 'always' ? 'underline' : null"
                                            [class.hover-underline]="header.hightlightText.underline === 'onHover'"
                                            [class.cursor-pointer]="header.hightlightText.action !== undefined"
                                            (click)="
                                                header.hightlightText.action !== undefined &&
                                                header.hightlightText.action(item)"
                                        >{{ !header.convertFunction
                                            ? (!header.isUppercase ? subText.text : subText.text | uppercase)
                                            : header.convertFunction(!header.isUppercase ? subText.text : subText.text | uppercase) }}</span>
                                       }
                                     }
                                    }
                                    @else if(header.isUppercase) {
                                        {{ toString(getPropertyValue(item, header.dataName)) | uppercase }}
                                    }
                                    @else {
                                        {{ getPropertyValue(item, header.dataName) }}
                                    }
                                }
                              }
                              </div>
                            </td>
                          }
                        }

                        @if (showSwitches && !rowSwitchDisabledFunction) {
                            <td class="d-flex justify-content-end switch-td" style="min-width: 120px;">
                                <app-so-switch
                                    [customStyleOption]="'verde'"
                                    [labelLeft]="switchLabelLeft"
                                    [labelRight]="switchLabelRight"
                                    [labels]="true"
                                    (statusChecked)="onSwitchActivated(item, $event)"
                                    (click)="$event.stopPropagation()"
                                    [isChecked]="item[switchIdentifier]"
                                    [disabled]="item.disabledSwitch"
                                    [matTooltip]="item.disabledSwitch ?
                                        (rowSwitchDisabledTooltipFunction ? rowSwitchDisabledTooltipFunction(item) : disabledSwitchTooltip) :
                                        ''"
                                ></app-so-switch>
                            </td>
                        }@else if(showSwitches && rowSwitchDisabledFunction) {
                            <td class="d-flex justify-content-end switch-td" style="min-width: 120px;">
                                <app-so-switch
                                    [customStyleOption]="'verde'"
                                    [labelLeft]="switchLabelLeft"
                                    [labelRight]="switchLabelRight"
                                    [labels]="true"
                                    (statusChecked)="onSwitchActivated(item, $event)"
                                    (click)="$event.stopPropagation()"
                                    [isChecked]="item[switchIdentifier]"
                                    [disabled]="rowSwitchDisabledFunction(item)"
                                    [matTooltip]="rowSwitchDisabledFunction(item) ?
                                        (rowSwitchDisabledTooltipFunction ? rowSwitchDisabledTooltipFunction(item) : disabledSwitchTooltip) :
                                        ''"
                                ></app-so-switch>
                            </td>
                        }
                        @if (showIcons) {
                            <td class="" >
                                @for (icon of (item[iconsIdentifier] || []); track $index) {
                                    <app-so-svg-icon
                                        [src]="'assets/img/' + icon.icon + '.svg'"
                                        [size]="icon.iconSize"
                                        [color]="icon.iconColor"
                                        [tooltip]="icon.tooltipText || ''"
                                        [applyChange]="true"
                                    ></app-so-svg-icon>
                                }
                            </td>
                        }
                    </tr>
                }
                @empty {
                    <tr>
                        <td class="text-center pe-4 me-4" [attr.colspan]="getColspan()"  style="text-align: center;"> {{ 'no_data' | translated: 'Sin resultados' : lang }} </td>
                    </tr>
                }
            </tbody>
            @if (tableFeet !== null && (enablePagination ? filteredData : tableData).length) {
            <tfoot>
                <tr [style.height]="headersHeight">
                  @if (isActionsEnabled) {
                    <td [style.width]="buttonsContainerWidth" [style.paddingLeft]="buttonsContainerPaddingLeft"></td>
                  }
                 @for (header of tableHeaders; track columnIndex; let columnIndex = $index) {
                   @if (shouldShowColumn(header)) { <!-- Nuevo condicional -->
                    <td
                        class="fw-bold"
                        [class.sticky-left]="columnIndex === firstColumnIndex && firstColumnStickyLeft"
                        [style.padding-left]="columnIndex === firstColumnIndex && headerStyle === 'new' && firstColumnPaddingLeft"
                        [style.padding-right]="columnIndex === lastColumnIndex && lastColumnPaddingRight"
                        [style.color]="headerStyle === 'new' && headersColorIsPrimary && 'var(--so-primary)'"
                        [style.width]="header.columnWidth || 'auto'"
                    >
                        <div [style]="header.customTDStyle || ''">
                          @if(footerHighlight && header.hightlightText){ <!-- Textos resaltados / con interacción-->
                           @for(subText of tableFeetHighlights[columnIndex]; track subText; let subTextIndex = $index){
                            @if (!subText.highlighted){
                            <span>{{ !header.convertFunction
                                ? (!headersCaseIsUpper && !header.isUppercase ? subText.text : subText.text | uppercase)
                                : (header.convertFunction(!headersCaseIsUpper && !header.isUppercase ? subText.text : subText.text | uppercase)) }}</span>
                            }
                            @else {
                            <span
                                [style.color]="header.hightlightText.color ? ('var(' + header.hightlightText.color + ')') : null"
                                [style.text-decoration-thickness]="'1.5px'"
                                [style.text-decoration-line]="header.hightlightText.underline === 'always' ? 'underline' : null"
                                [class.hover-underline]="header.hightlightText.underline === 'onHover'"
                                [class.cursor-pointer]="header.hightlightText.action !== undefined"
                                (click)="
                                    header.hightlightText.action !== undefined &&
                                    header.hightlightText.action(tableFeet)"
                            >{{ !header.convertFunction
                                ? (!headersCaseIsUpper && !header.isUppercase ? subText.text : subText.text | uppercase)
                                : header.convertFunction(!headersCaseIsUpper && !header.isUppercase ? subText.text : subText.text | uppercase) }}</span>
                            }
                           }
                          }
                          @else {
                            {{ !header.convertFunction
                                ? (!headersCaseIsUpper && !header.isUppercase ? tableFeet[header.dataName] : toString(tableFeet[header.dataName]) | uppercase)
                                : header.convertFunction(!headersCaseIsUpper && !header.isUppercase ? tableFeet[header.dataName] : toString(tableFeet[header.dataName]) | uppercase) }}
                          }
                        </div>
                    </td>
                    }
                 }
                 @if(showSwitches){
                    <td class="text-end pe-5" style="min-width: 120px;">{{ switchHeader | uppercase}}</td>
                 }
                 @if(showIcons){
                    <td class="text-end pe-5" style="min-width: 120px;">{{ iconsHeader | uppercase }}</td>
                 }
                </tr>
            </tfoot>
            }
        </table>
    </div>
    @if (enableSaveButton && !enablePagination) {
        <div class="d-flex first-data justify-content-end">
            <app-button
                class="pe-4"
                type="button"
                [text]="'save' | translated: 'Guardar' : lang"
                svg="mdi-content-save"
                [iconAlignment]="'right'"
                [injection]="{icon: 'margin-top: 0px !important', button: '' }"
                [applyStyles]="false"
                [applyChanges]="true"
                [width]="'100%'"
                (clicked)="save()"
            ></app-button>
        </div>
    }
    @if(enablePagination){
        <div
        class="d-flex"
        [ngClass]="enableSaveButton || enableLeftButton ? 'justify-content-between' : 'justify-content-end'">
            @if(enableLeftButton){
                <app-button
                    type="button"
                    [text]="leftButtonData.text"
                    [svg]="leftButtonData.icon"
                    [iconAlignment]="'right'"
                    [injection]="{icon: 'margin-top: 0px !important;', button: '' }"
                    [applyStyles]="false"
                    [applyChanges]="true"
                    [disabled]="leftButtonData.disabled"
                    [matTooltip]="leftButtonData.disabled ? leftButtonData.tooltip : ''"
                    [width]="'100%'"
                    (click)="leftButtonAction()"
                ></app-button>
            }
            <so-pagination
                [lang]="lang"
                [totalItems]="searchText ? filteredData.length : tableData.length"
                [itemsPerPage]="itemsPerPage"
                [currentPage]="currentPage"
                [loadingItems]="loadingItems"
                (pageChanged)="onPageChanged($event)"
            ></so-pagination>
            @if (enableSaveButton) {
                <app-button
                    class="pe-4"
                    type="button"
                    [text]="'save' | translated: 'Guardar' : lang"
                    svg="mdi-content-save"
                    [iconAlignment]="'right'"
                    [injection]="{icon: 'margin-top: 0px !important', button: '' }"
                    [applyStyles]="false"
                    [applyChanges]="true"
                    [width]="'100%'"
                    (clicked)="save()"
                ></app-button>
            }
        </div>
    }
</div>
